import Icon from "@bokio/designsystem/components/Icon/Icon";
import { BankLangFactory } from "@bokio/lang";

import type { FontelloIcons } from "@bokio/assets/fontello";
import type { IconColor, IconSize } from "@bokio/designsystem/components/Icon/Icon";

interface BokioBusinessAccountIconProps {
	className?: string;
	color?: IconColor;
	size?: IconSize;
	iconName?: FontelloIcons;
}

//@TODO this component is not needed. Just use the Icon component right away.
export const BokioBusinessAccountIcon = ({ className, color, size, iconName }: BokioBusinessAccountIconProps) => {
	const bankLang = BankLangFactory();
	return (
		<Icon
			color={color ?? "blue"}
			name={iconName ?? "bba-filled"}
			className={className}
			title={bankLang.BokioBusinessAccount}
			size={size}
		/>
	);
};
